<template>
  <div class="orderDetails">
    <div class="pre-order-card">
      <div class="product-card" @click="goToProductDetail(preOrderDetailSection.saleProductDetailsDTO.saleReferenceID,'NORMAL')">
        <span
          v-lazyload
          class="product-img image__wrapper"
          v-if="preOrderDetailSection.displayImage"
          
        >
          <ImageSpinner class="image__spinner" />
          <img
            class="image__item"
            :data-url="preOrderDetailSection.displayImage"
            :alt="preOrderDetailSection.productName"
          />
        </span>
        <div class="product-detail">
          <div class="product-title">
            <h4>{{preOrderDetailSection.productName}}</h4>
          </div>
          <div class="color-size" v-if="preOrderDetailSection.color || preOrderDetailSection.size">
            <span class="product-color" v-if="preOrderDetailSection.color">
              {{$t('color')}} :&nbsp;
              <span class="colour">
                {{preOrderDetailSection.color}}
              </span>
            </span>
            <span class="product-sz" v-if="preOrderDetailSection.size">
              {{$t('size')}} :&nbsp;
              <span class="size"> {{preOrderDetailSection.size}}</span>
            </span>
          </div>


          <p v-if="preOrderDetailSection.saleProductDetailsDTO">{{$t('seller')}}: {{preOrderDetailSection.saleProductDetailsDTO.sellerName}}</p>
          <span class="card-bottom-text" v-if="preOrderDetailSection.saleProductDetailsDTO">{{$t('peopleBoughtThisDeal',{people:preOrderDetailSection.saleProductDetailsDTO.peopleBought})}}</span>
        </div>
      </div>
    </div>
    <div class="order-notify-msg">
      <p>{{$t('colorPrintsMayvary')}}</p>
      <p>{{$t('reachIn15Days')}}</p>
    </div>
    
  </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "orderDetails",
  components: {
    ImageSpinner
  },
  props: {
    dataValues: {
      type: Object,
      required: true
    },
    countDownTimer: {
      type: String
    }
  },
  data() {
    return {
      preOrderDetailSection: { },
      setTimeText: "",
      offsetValue: 116
    };
  },
  watch: {
    dataValues() {
      if(this.dataValues){
        this.preOrderDetailSection = this.dataValues;
      }
    },
    countDownTimer() {
      this.setTimeText = this.countDownTimer;
    }
  },
  methods: {
    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    }
  },
  mounted() {
    
    if(this.dataValues){
        this.preOrderDetailSection = this.dataValues;
    }
    this.$store.commit("saveData", {
      orders: [],
      orderIndex: 0,
      type: "post_order"
    });
    this.$store.commit("saveData", {
      preOrders: [],
      preOrderIndex: 0,
      type: "pre_orders"
    });
  }
};
</script>
